import { useEffect } from "react";
// import FullScreenLoader from "../../components/molecules/Loader/FullScreenLoader";
import { useSearchParams } from "react-router-dom";
import useAccountActions from "../../hooks/useAccountActions";
import useAuth from "../../hooks/useAuth";
import Loader from "../../components/Loader/Loader";
import { usePortal } from "../../hooks/usePortal";

const SUCCESS_QUERY_PARAM = "signout-success";

export const SingleSignout = () => {
  const { isLoading, isLoggingOut } = useAuth();
  const { portalUrl } = usePortal();
  const { logoutB2C } = useAccountActions();
  const [searchParams] = useSearchParams();
  const isLogoutCompleted = searchParams.get(SUCCESS_QUERY_PARAM) === "1";

  useEffect(() => {
    if (!isLoading && logoutB2C) {
      logoutB2C({ isLoadingInIframe: true });
    }
  }, [isLoading, logoutB2C]);

  useEffect(() => {
    if (isLogoutCompleted) {
      const url = new URL(portalUrl);
      // Notify the parent window
      window.parent.postMessage(
        { eventName: "SIGNOUT_SUCCESS", details: { success: true } },
        // Explicit target origin for security
        url?.origin,
      );
    }
  }, [isLogoutCompleted, portalUrl]);

  let loadingText = "Loading account information...";

  if (isLoggingOut) {
    loadingText = "Logging you out of this Therapeutic Guidelines app.";
  }
  if (isLogoutCompleted) {
    loadingText = "All done. You've been logged out of this Therapeutic Guidelines app.";
    return <>{loadingText}</>;
  }
  // return <FullScreenLoader message={loadingText} isLoading={!isLogoutCompleted} />;
  return <Loader />;
};
